const code = {
    path: '/code',
    name: 'FindCode',
    icon: 'iconfont icon-tongji',
    component: () => import('@/pages/layout/appMain'),
    redirect: '/code/findCode',
    children: [
        {
            name: 'findCode',
            icon: 'el-icon-user',
            path: '/findCode',
            component: () => import('@/pages/code/findCode.vue')
        }
    ]
}
export default code